module.exports = __webpack_public_path__ + "assets/img/8_1463.45b82739.jpg";